import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Experience from '../components/Experience';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import useScrollReveal from '../hooks/useScrollReveal';

const HomePage = () => {
  useScrollReveal();

  return (
    <div className="min-h-screen bg-slate-950">
      <SEO />
      <Header />
      <Hero />
      <About />
      <Experience />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
